// src/pages/JudoCoachPro/JudoCoachPro.jsx

import React from "react";

import Footer from "../Home/Footer";
import FormContact from "../Home/FormContact";

import AuthIcons from "../../hooks/AuthIcons";
import useScrollToTop from "../../hooks/useScrollToTop";
import { useUser } from "../../contexts/UserContext";

import JudoCoachProHero from "./components/JudoCoachProHero";
import JudoCoachProAudienceBar from "./components/JudoCoachProAudienceBar";
import JudoCoachProFeatures from "./components/JudoCoachProFeatures";
import JudoCoachProPricing from "./components/JudoCoachProPricing";

export default function JudoCoachPro() {
  useScrollToTop();

  const { user } = useUser();

  return (
    <div className="min-h-screen bg-white text-slate-950 dark:bg-slate-950 dark:text-white">
      {!user ? <AuthIcons /> : null}

      <main>
        <JudoCoachProHero />

        <JudoCoachProAudienceBar />

        <JudoCoachProFeatures />

        <JudoCoachProPricing />

        {/*
          Prochaines sections :
          - fonctionnalités
          - formules
          - galerie
          - accès gratuit et soutien du projet
          - accompagnement
        */}

        <section
          id="contact"
          className="scroll-mt-24 bg-white py-16 dark:bg-slate-950 sm:py-20"
        >
          <div className="mx-auto max-w-[1480px] px-4 sm:px-6 lg:px-8">
            <div className="mb-10 grid gap-6 border-b border-slate-200 pb-9 dark:border-white/10 lg:grid-cols-[1fr_0.8fr] lg:items-end">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#0868f2] dark:text-blue-300">
                  Découvrir Judo Coach Pro
                </p>

                <h2 className="mt-4 text-4xl font-semibold leading-tight tracking-[-0.04em] text-slate-950 dark:text-white sm:text-5xl">
                  Une question ou besoin
                  <span className="block text-[#0868f2] dark:text-blue-300">
                    d’une présentation ?
                  </span>
                </h2>
              </div>

              <p className="max-w-xl text-base leading-8 text-slate-600 dark:text-slate-300 lg:justify-self-end">
                Présentez-moi votre club, vos groupes et vos besoins. Je vous
                montrerai comment Judo Coach Pro peut accompagner vos
                enseignants et vos judokas.
              </p>
            </div>

            <FormContact />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}